/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Weight_RecentInputs */

const en_us2_profile_weight_recent = /** @type {(inputs: Profile_Weight_RecentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recent entries`)
};

const pt_br2_profile_weight_recent = /** @type {(inputs: Profile_Weight_RecentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Registros recentes`)
};

const es_419_profile_weight_recent = /** @type {(inputs: Profile_Weight_RecentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Registros recientes`)
};

const pt_pt2_profile_weight_recent = /** @type {(inputs: Profile_Weight_RecentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Registos recentes`)
};

const fr_fr2_profile_weight_recent = /** @type {(inputs: Profile_Weight_RecentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entrées récentes`)
};

const de_de2_profile_weight_recent = /** @type {(inputs: Profile_Weight_RecentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Letzte Einträge`)
};

const it_it2_profile_weight_recent = /** @type {(inputs: Profile_Weight_RecentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Registrazioni recenti`)
};

/**
* | output |
* | --- |
* | "Recent entries" |
*
* @param {Profile_Weight_RecentInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_weight_recent = /** @type {((inputs?: Profile_Weight_RecentInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Weight_RecentInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_weight_recent(inputs)
	if (locale === "es-419") return es_419_profile_weight_recent(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_weight_recent(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_weight_recent(inputs)
	if (locale === "de-DE") return de_de2_profile_weight_recent(inputs)
	if (locale === "it-IT") return it_it2_profile_weight_recent(inputs)
	return en_us2_profile_weight_recent(inputs)
});
export { profile_weight_recent as "profile.weight_recent" }